import {useMemo} from 'react';
import {useParams} from 'react-router';
import {assert} from 'assert-ts';
import {useQueryParams} from 'navigation/hooks';
import type {NewPrizeParam, PrizeIdParam} from '../types';

export const usePrizeUrlParameters = (): PrizeIdParam | NewPrizeParam => {
  const {prizeId} = useParams();
  const queryParams = useQueryParams<{
    suggestion: string;
  }>();

  return useMemo(() => {
    return prizeId === 'new'
      ? {
          suggestion: queryParams.suggestion,
        }
      : {
          prizeId: assert(prizeId, 'usePrizeUrlParameters: prizeId expected', {
            prizeId,
            queryParams,
          }),
        };
  }, [prizeId, queryParams]);
};
